import { h, Component } from 'preact';
import pure from 'utils/pure';
import Store from 'store/store';
import 'store/bolt/cookies';
import s from 'components/bolt/cookies/cookies.sss';
import { addClass, removeClass, accessNested, joinClasses } from 'utils/utils';
import HTML from 'components/core/html/html.js';

export default @pure class Cookies extends Component {
	constructor(props, ...args) {
		super(props, ...args);

		this.state = {
			locked: accessNested(props, 'appData.options.cookiesModal.lockout', false),
			// display: true
		};

		this.acceptAll = this.acceptAll.bind(this);
		this.displaySettings = this.displaySettings.bind(this);
		this.stickyHeader = this.stickyHeader.bind(this);
	}

	// LIFECYCLE METHODS
	componentDidMount() {
		if (typeof document === 'undefined') {
			return;
		}

		if (this.state.locked) {
			addClass(document.body, 'cookieScrollLock');
		}

		if (window.history && 'scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}
		// The cookie component should not be in charge of that on mount - otherwise will lead to inconsistencies if/when it is not present
		// window.scroll(0, 0);

		const fixedTop = accessNested(this.props, 'appData.options.cookiesModal.position', '') === 'fixedTop';
		if (fixedTop) {
			this.header = document.getElementById('header') || {};
			this.headerOffset = this.header.offsetTop;
			window.addEventListener('scroll', this.stickyHeader);
		}

		if (window.ResizeObserver) {
			let cookieHeight;
			this.resizeObserver = new ResizeObserver(entries => {
				cookieHeight = entries[0].contentRect.height;
				Store.emit('SET_COOKIE_BAR_HEIGHT', cookieHeight);
			});
			this.resizeObserver.observe(this.$cookie);
		} else {
			Store.emit('SET_COOKIE_BAR_HEIGHT', this.$cookie.offsetHeight);
		}
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.stickyHeader);
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
	}

	// EVENT HANDLING
	stickyHeader() {
		// const isDisplaying =  accessNested(this.state, 'display', true);
		// if (isDisplaying) {
		// 	if (window.pageYOffset >= this.headerOffset) {
		// 		this.header.style.position = 'fixed';
		// 		this.header.style.top = '0px';
		// 	} else {
		// 		this.header.style.position = 'fixed';
		// 		this.header.style.top = `${this.$cookie.offsetHeight - window.pageYOffset}px`;
		// 	}
		// } else {
		// 	this.header.style.position = 'fixed';
		// 	this.header.style.top = '0px';
		// 	window.removeEventListener('scroll', this.stickyHeader);
		// }
	}

	acceptAll() {
		if (this.props.onAccept) {
			this.props.onAccept();
		}

		if (typeof document !== 'undefined') {
			removeClass(document.body, 'cookieScrollLock');
		}
		// this.setState({ display: !this.state.display });

		Store.emit('ACCEPT_COOKIES', this.props.categories);
	}

	displaySettings() {
		Store.emit('COOKIE_PREFERENCES_OPEN');
	}

	render(props) {
		const { locked } = this.state;
		const { options = {}, copy = {} } = props.appData || {};
		const { cookiesModal = {} } = options;
		const { legalCopy, position } = cookiesModal;
		const stickyTop = position === 'stickyTop';
		const stickyBottom = position === 'stickyBottom';
		const fixedTop = position === 'fixedTop';
		const float = position === 'float';
		const href = cookiesModal.link || accessNested(props, 'appData.urls.cookieTextLink');
		const fontStyles = accessNested(props, 'appData.styling.fontVariables');

		return (
			<div class={joinClasses(s.cookiesContainer, props.hidden && s.hidden)} ref={ref => this.$cookie = ref}>
				{locked && <div class={s.lockout} />}
				<div
					class={joinClasses({
						s, container: true,
						top: stickyTop,
						float,
						fixedTop,
						bottom: stickyBottom,
						display: this.state.display
					})}
					key="cookie"
					data-section="cookies"
				>
					<div class={s.spacer}>
						<div class={joinClasses(s.text, fontStyles.cookieBannerCopy)}>
							{legalCopy ?
								<HTML tag="p" class={s.questionText} content={legalCopy} markdown />
								:
								(
									<p>
										<HTML tag="span" markdown>{copy.baseCopy.$COOKIE_TEXT_START}</HTML>
										<span> </span>
										<a
											href={href} target="_blank" class={fontStyles.cookiePolicyLink}
											onClick={e => {
												const pageId = accessNested(props, `appData.pages.${href}`, null);
												if (pageId) {
													// Store.emit('COOKIE_PREFERENCES_CLOSE');
													// Store.emit('COOKIE_BANNER_CLOSE');
													Store.emit('CLOSE_AND_NAVIGATE', href, e);
												}
											}}
										>
											{copy.baseCopy.$COOKIE_LINK_COPY}
										</a>
										{copy.baseCopy.$COOKIE_TEXT_END}
									</p>
								)
							}
						</div>
						<div class={s.buttonWrapper}>
							<button
								class={joinClasses(s.accept, s.button, fontStyles.cookieAcceptBtn)}
								onClick={this.acceptAll}
							>
								{copy.baseCopy.$ACCEPT_COOKIES}
							</button>
							<button
								class={joinClasses(s.settings, s.button, fontStyles.cookieManageBtn)}
								onClick={this.displaySettings}
							>
								{copy.baseCopy.$COOKIE_SETTINGS}
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
